
<Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
  <h1 class="text-h2 centered mt-24 mb-16">Other requirements</h1>
  <p class="text-body centered mb-24">What other requirements and responsibilities should sitters be aware of?</p>

  <form>
    <h2 class="text-small font-medium">Requirements</h2>
    <RequirementsSection :requirements.sync="requirements" :languages.sync="languages" />
    <h2 class="text-small font-medium">Responsibilities</h2>
    <ResponsibilitiesSection :responsibilities.sync="responsibilities" />
    <div class="flex flex-row-reverse">
      <RouteStepperNextButton :stepData="reviewSection" :draftData="draftData" />
    </div>
  </form>
</Card>
